<template>
  <v-container class="pa-0">
    <v-img src="/img/cpa2.png" style="width: 180px" class="mx-auto mt-10 mb-5" />
    <v-card class="rounded-t-xl pa-0 ma-0">
      <div class="text-h5 text-center font-weight-black pt-5">Login Visitante</div>
      <v-form ref="form" class="pa-5">
        <v-text-field v-model="cpf" name="cpf" label="CPF" autocomplete="off" required></v-text-field>
        <v-text-field v-model="senha" name="senha" type="password" label="Celular" required></v-text-field>
      </v-form>
      <v-row align="center"></v-row>
      <v-card-actions class="pr-5">
        <v-spacer></v-spacer>
        <v-btn
          class="cyan darken-2 white--text my-2"
          @click="loginVisitante({ cpf, senha })"
        >Acessar</v-btn>
      </v-card-actions>
    </v-card>
    <div
      class="text-caption text-center"
    >Sistema Desenvolvido por Revolution Serviços <a href="//wa.me/5551999926208">(51) 99992-6208</a></div>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'


export default {
  data: () => ({
    cpf: '',
    senha: ''
  }),
  methods: {
    ...mapActions(['loginVisitante'])
  }
}
</script>
<style scoped>

</style>
